import React from 'react';
import styles from './ItemFilterViewN.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const itemKinds = [
  {'icon':'','name':'원거리무기', 'value':'01'},
  {'icon':'','name':'근거리무기', 'value':'02'},
  {'icon':'','name':'방패', 'value':'03'},
  {'icon':'','name':'방어구', 'value':'04'},
  {'icon':'','name':'악세서리', 'value':'05'},
  {'icon':'','name':'코스튬날개', 'value':'06'},
];
const itemFilterDtl = {
  'itemFilter1':[
    {'name':'CL', value:'Y'},
    {'name':'NonCL', value:'N'},
    {'name':'합법', value:'N'},
    {'name':'불법', value:'Y'},
  ],
  'itemFilter2':new Array(12).fill(0,0,12),
  'itemFilter3':[
    {'name':'저격소총', 'kind':'원거리무기종류'},
    {'name':'돌격소총', 'kind':'원거리무기종류'},
    {'name':'기관총', 'kind':'원거리무기종류'},
    {'name':'중화기', 'kind':'원거리무기종류'},
    {'name':'지원화기', 'kind':'원거리무기종류'},
    {'name':'샷건', 'kind':'원거리무기종류'},
    {'name':'권총', 'kind':'원거리무기종류'},
    {'name':'특수화기', 'kind':'원거리무기종류'}
  ],
  'itemFilter4':[
    {'name':'도검', 'kind':'근거리무기종류'},
    {'name':'둔기', 'kind':'근거리무기종류'},
    {'name':'도끼', 'kind':'근거리무기종류'},
    {'name':'장창', 'kind':'근거리무기종류'},
    {'name':'미늘창', 'kind':'근거리무기종류'}
  ]
  ,'itemFilter5':[
    {'name':'감염체전용의상', 'kind':'방어구종류'},
    {'name':'남성가발', 'kind':'방어구종류'},
    {'name':'남성모자', 'kind':'방어구종류'},
    {'name':'남성상의', 'kind':'방어구종류'},
    {'name':'남성신발', 'kind':'방어구종류'},
    // {'name':'남성자켓상의, 'kind':'방어구종류''},
    {'name':'남성코트', 'kind':'방어구종류'},
    {'name':'남성하의', 'kind':'방어구종류'},
    {'name':'여성가발', 'kind':'방어구종류'},
    {'name':'여성모자', 'kind':'방어구종류'},
    {'name':'여성상의', 'kind':'방어구종류'},
    {'name':'여성스타킹', 'kind':'방어구종류'},
    {'name':'여성신발', 'kind':'방어구종류'},
    // {'name':'여성자켓상의, 'kind':'방어구종류''},
    {'name':'여성코트', 'kind':'방어구종류'},
    {'name':'여성하의', 'kind':'방어구종류'}
  ],
  'itemFilter6':[
    {'name':'벨트', 'kind':'악세서리종류'},
    {'name':'귀걸이', 'kind':'악세서리종류'},
    {'name':'목걸이', 'kind':'악세서리종류'},
    {'name':'팔찌', 'kind':'악세서리종류'},
    {'name':'반지', 'kind':'악세서리종류'},
    {'name':'왼손반지', 'kind':'악세서리종류'},
    {'name':'환생악세', 'kind':'악세서리종류'}
  ],
  'itemFilter7':[
    {'name':'코스튬', 'kind':'코튬날개종류'},
    {'name':'날개', 'kind':'코튬날개종류'},
    {'name':'토이', 'kind':'코튬날개종류'}
  ]
}

const ItemFilterView = ({onChangeItemKind, onChangeItemFilter, onChangeTextFilter, onClickFilterInit, itemFilters}) => {

  const {itemKind, clyn, illegal, tier, itemDtlDv01, itemDtlDv02, itemDtlDv03, itemDtlDv04, itemDtlDv05, filterText} = itemFilters;

  const itemKindHtml = itemKinds.map((ele, cnt) => {
      const {/*icon, */name, value} = ele;
      const checked = itemKind === value;
      
      return (
        <React.Fragment key={`itemKind-${cnt}`}>
          <input type="radio" name="itemkind" onChange={onChangeItemKind} 
          value={value} id={`itemkind_radio${cnt+1}`} checked={checked} />
          <label htmlFor={`itemkind_radio${cnt+1}`}>
            {name}
          </label>
        </React.Fragment>
      )
  });

  const itemFilterRender = (flag, itemKind) => {
    const filterTemplate = itemFilterDtl[`itemFilter${flag}`];
      
    const filterHtml = filterTemplate.map((filter, cnt) => {
      const {name, value, kind} = filter;
      const nameValue = flag === '2' ? String(cnt+1) : flag === '1' ? value : name;
      const altValue = flag === '2' ? '등급' : flag === '1' ? name : kind;
      const textValue = flag === '2' ? `${cnt+1}등급` : name;
      let checked = false;

      if(flag === '1') {
        if(altValue.indexOf('CL') > -1) {
          checked = clyn.some(ele => ele === nameValue);
        }else{
          checked = illegal.some(ele => ele === nameValue);
        }
      }else if(flag === '2') {
        checked = tier.some(ele => ele === nameValue);
      }else if(flag === '3') {
        checked = itemDtlDv01.some(ele => ele === nameValue);
      }else if(flag === '4') {
        checked = itemDtlDv02.some(ele => ele === nameValue);
      }else if(flag === '5') {
        checked = itemDtlDv03.some(ele => ele === nameValue);
      }else if(flag === '6') {
        checked = itemDtlDv04.some(ele => ele === nameValue);
      }else if(flag === '7') {
        checked = itemDtlDv05.some(ele => ele === nameValue);
      }

      if(itemKind !== '01' && itemKind !== '02' && (name === '합법' || name === '불법')) {
        return null;
      }
  
      return (
        <>
          <input type="checkbox" onChange={onChangeItemFilter} 
          id={`filter_check${String(flag) + String(cnt+1)}`} 
          alt={altValue} name={nameValue} checked={checked} />
          <label htmlFor={`filter_check${String(flag) + String(cnt+1)}`}>
            {textValue}
          </label>
        </> 
      )
    });
  
    return filterHtml;
  }

  return (
    <main>
      {/* <div className={cx('warning-banner')}>
        <p className={cx('warning-text')}>
          <span className={cx('warning-tag')}>[WARNING]</span>
          감염체 활동이 탐지되었습니다...
          <span className={cx('cursor')}>▊</span>
        </p>
        <p className={cx('sub-text')}>ZONE-13 TERMINAL // DATA FEED ONLINE</p>
        <div className={cx('background-mark')}>BIOHAZARD</div>
      </div> */}

      {/* {JSON.stringify(itemFilters)} */}
      <div className={cx('button-group')}>
        {itemKindHtml}
      </div>
      <div className={cx('button-group')}>
        {itemFilterRender('1', itemKind)}
      </div>
      {itemKind === '01' || itemKind === '02' || itemKind === '03' || itemKind === '04' ?
      <div className={cx('button-group')}>{itemFilterRender('2')}</div>
      : <div className={cx('button-group')}></div>}
      {itemKind === '01' ?
      <div className={cx('button-group')}>{itemFilterRender('3')}</div>
      : itemKind === '02' ?
      <div className={cx('button-group')}>{itemFilterRender('4')}</div>
      : itemKind === '04' ?
      <div className={cx('button-group')}>{itemFilterRender('5')}</div>
      : itemKind === '05' ?
      <div className={cx('button-group')}>{itemFilterRender('6')}</div>
      : itemKind === '06' ?
      <div className={cx('button-group')}>{itemFilterRender('7')}</div>
      : <div className={cx('button-group')}></div>
      }

      <div className={cx('search-row')}>
        <input type="text" placeholder="이름으로 찾기" value={filterText} onChange={onChangeTextFilter} /*autoFocus*/ />
        <button className={cx('filter-init')} onClick={onClickFilterInit}>검색필터초기화</button>
      </div>
    </main>
  );
}

export default ItemFilterView;